var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_255_9359",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_255_9359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.125 20.5C4.60833 20.5 4.175 20.325 3.825 19.975C3.475 19.625 3.3 19.2 3.3 18.7V15.125H4.8V18.7C4.8 18.7667 4.83333 18.8333 4.9 18.9C4.96667 18.9667 5.04167 19 5.125 19H18.875C18.9583 19 19.0333 18.9667 19.1 18.9C19.1667 18.8333 19.2 18.7667 19.2 18.7V5.3C19.2 5.23333 19.1667 5.16667 19.1 5.1C19.0333 5.03333 18.9583 5 18.875 5H5.125C5.04167 5 4.96667 5.03333 4.9 5.1C4.83333 5.16667 4.8 5.23333 4.8 5.3V8.875H3.3V5.3C3.3 4.8 3.475 4.375 3.825 4.025C4.175 3.675 4.60833 3.5 5.125 3.5H18.875C19.3917 3.5 19.825 3.675 20.175 4.025C20.525 4.375 20.7 4.8 20.7 5.3V18.7C20.7 19.2 20.525 19.625 20.175 19.975C19.825 20.325 19.3917 20.5 18.875 20.5H5.125ZM10.5 16.45L9.45 15.375L12.075 12.75H3.3V11.25H12.075L9.45 8.625L10.5 7.55L14.95 12L10.5 16.45Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.acfcfaf80e8efa2c9f625b40e8c0830e.svg";
export { ForwardRef as ReactComponent };